import React from "react";
import metakLogo from "../images/logo/METAKLOGO.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { serverUrl } from "../utils/Constants";

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    const username = e.target.username.value;
    const password = e.target.password.value;
    // console.log(username, password);

    try {
      const response = await axios.post(`${serverUrl}/login.php`, {
        username,
        password,
      });

      // console.log(response.data);
      const { status, message } = response.data;

      if (status) {
        // Handle successful login
        // console.log("Login successful");
        login();
        // Redirect to admin dashboard
        navigate("/admin/dashboard");
      } else {
        // Handle invalid credentials
        // console.log(message);
        console.error("Login failed:", message);
        alert(message); // Show an error message to the user
      }
    } catch (error) {
      if (!error.response) {
        // Server didn't respond or network error
        console.error("Error connecting to server:", error.message);
        alert("Failed to connect to server. Please try again later.");
      }
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card shadow p-4" style={{ maxWidth: "400px", width: "100%" }}>
        <div className="text-center mb-4">
          {/* Replace the src with your logo URL */}
          <img src={metakLogo} alt="Logo" className="img-fluid mb-3" />
          <h4>Admin Login</h4>
        </div>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label htmlFor="username" className="form-label">
              Username
            </label>
            <input type="text" className="form-control" id="username" placeholder="Enter your username" required />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input type="password" className="form-control" id="password" placeholder="Enter your password" required />
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
